<mat-card class="validate-card">
    <mat-card-header>
        <mat-card-title><fa-icon [icon]="['fas','euro-sign']"></fa-icon>&nbsp;&nbsp;Assurabilité</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="flex-container" fxLayout="row" fxLayoutGap="5px">
            <app-insurance-selection fxFlex [insurance]="patient.insurance" (selected)="insuranceSelected($event)"></app-insurance-selection>
            <mat-form-field fxFlex class="field-full-width">
                <mat-label>CT1/CT2</mat-label>
                <input matInput [value]="patient.mutregime" mat-autoresize="true" placeholder="Régime mutuelle">
            </mat-form-field>
        </div>
    </mat-card-content>
</mat-card>